<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    disable: groupErrorReportForm.invalid,
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getGroupErrorReport()"
>
  <form class="collected-container" [formGroup]="groupErrorReportForm">
    <app-from-to-date
      [fromControl]="'fromDate'"
      [toControl]="'toDate'"
      [customMaxToDate]="customMaxDate"
      [customMaxFromDate]="customMaxDate"
      [minSelectableDays]="7"
      [formGroupValue]="groupErrorReportForm"
    ></app-from-to-date>

    <!-- Report Format -->
    <ion-row>
      <ion-col>
        <app-report-format
          [radioButtonValue]="groupErrorReportForm.get('reportFormat')?.value"
          (emitRadioChange)="radioChange($event)"
        ></app-report-format>
      </ion-col>
    </ion-row>

    <!-- Note -->
    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"></app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    groupErrorReportResponse && groupErrorReportResponse.response.groupError
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
  [columnDataFontSize]="'10px'"
>
</app-pdf-report-generator>
